import React from 'react';

import ToggleSet from '../../common/toggle-set';

class MultiCurrencyMenu extends React.Component {
  constructor(props) {
    super(props);

    this.currencies = [
      {
        reference: 'usd',
        label: 'USD ($)',
      },
      {
        reference: 'gbp',
        label: 'GBP (£)',
      },
      {
        reference: 'aud',
        label: 'AUD ($)',
      },
      {
        reference: 'cad',
        label: 'CAD ($)',
      },
      {
        reference: 'eur',
        label: 'EUR (€)',
      },
    ];

    this.state = {
      expanded: false,
    };
  }

  currentCurrency() {
    if (this.props.cartCurrency) {
      return this.props.cartCurrency;
    }

    return 'usd';
  }

  render() {
    return (
      <>
        {(this.state.expanded) ? (
          <ToggleSet
            items={this.currencies.map((val) => {
              return {
                label: val.label,
                selected: val.reference === this.currentCurrency(),
                onClick: () => {
                  this.props.onMultiCurrencyChange(val.reference);
                  this.setState({ expanded: false })
                }
              }
            })}
          />
        ) : (
          <button
            className="change-link"
            onClick={ () => this.setState({ expanded: true })}
          >
            {(this.props.cartCurrency) ? 'Change Currency' : 'Select Currency'}
          </button>
        )}
      </>
    );
  }
}

export default MultiCurrencyMenu;